import './bootstrap.js';

import { createApp } from 'vue';

import Accordion from './components/Accordion.vue';
import Button from './components/Button.vue';
import Estimate from './components/Estimate.vue';
import Foot from './components/Foot.vue';
import Heading from './components/Heading.vue';
import Icon from './components/Icon.vue';
import Logo from './components/Logo.vue';
import Navbar from './components/Navbar.vue';
import Page from './components/Page.vue';
import RentalEstimate from './components/RentalEstimate.vue';
import SiteHeader from './components/SiteHeader.vue';
import SiteFooter from './components/SiteFooter.vue';
import Snackbar from './components/Snackbar.vue';

const app = createApp({});

app.component('Accordion', Accordion);
app.component('Button', Button);
app.component('Estimate', Estimate);
app.component('Foot', Foot);
app.component('Heading', Heading);
app.component('Icon', Icon);
app.component('Logo', Logo);
app.component('Navbar', Navbar);
app.component('Page', Page);
app.component('rental-estimate', RentalEstimate);
app.component('site-header', SiteHeader);
app.component('site-footer', SiteFooter);
app.component('snackbar', Snackbar);

app.mount('#app');
